<section class="py-16 bg-dark-light">
  <div class="container mx-auto px-4">
    <h2 class="text-3xl md:text-4xl font-bold mb-12 text-center text-light text-shadow-glow">Wat Onze Gebruikers Zeggen</h2>
    
    <div class="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
      <div *ngFor="let testimonial of testimonials" class="bg-dark p-6 rounded-lg shadow-md border border-primary/20">
        <div class="flex items-center mb-4">
          <div class="flex">
            <span *ngFor="let star of [].constructor(testimonial.rating)" class="text-primary text-xl">★</span>
            <span *ngFor="let star of [].constructor(5 - testimonial.rating)" class="text-gray-600 text-xl">★</span>
          </div>
        </div>
        <p class="text-gray-300 mb-4 italic relative">
          <span class="text-5xl font-serif absolute -top-4 -left-4 text-primary/30">“</span>
          {{ testimonial.text }}
        </p>
        <div class="border-t border-gray-700 pt-4 text-right">
          <p class="font-semibold text-light">{{ testimonial.name }}</p>
          <p class="text-sm text-gray-500">{{ testimonial.location }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

